import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EventDetailsSection, EventDetailsSectionTitle } from '../EventDetails';

export type RefundPolicyProps = {
    isEnableRetainFeeActive: boolean;
    isPaidEvent: boolean;
    isRefundRequestAllowed: boolean;
    refundPolicyDescription: string;
    refundPolicyIsNoRefunds: boolean;
};

export const RefundPolicy = ({
    isEnableRetainFeeActive,
    isPaidEvent,
    isRefundRequestAllowed,
    refundPolicyDescription,
    refundPolicyIsNoRefunds,
}: RefundPolicyProps) => {
    if (!isPaidEvent) {
        return null;
    }
    const isNonFeeRefundable =
        isEnableRetainFeeActive && !refundPolicyIsNoRefunds;
    const isRequiredContactOrganizer =
        isEnableRetainFeeActive &&
        !refundPolicyDescription &&
        isRefundRequestAllowed;
    const isNonRefunds =
        isEnableRetainFeeActive &&
        !refundPolicyDescription &&
        !isRefundRequestAllowed;
    const LABEL_ID = 'refund-policy-heading';

    return (
        <EventDetailsSection ariaLabelledBy={LABEL_ID}>
            <EventDetailsSectionTitle>
                <h2>{gettext('Refund Policy')}</h2>
            </EventDetailsSectionTitle>

            {refundPolicyDescription && (
                <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: refundPolicyDescription.toString(),
                    }}
                />
            )}
            {isRequiredContactOrganizer && (
                <div>
                    {gettext('Contact the organizer to request a refund.')}
                </div>
            )}
            {isNonFeeRefundable && !isNonRefunds && (
                <div>{gettext("Eventbrite's fee is nonrefundable.")}</div>
            )}
            {isNonRefunds && <div>{gettext('No Refunds')}</div>}
        </EventDetailsSection>
    );
};
